import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import HeroImg0 from "../../assets/images/InternationalAcademy/Hero.jpg";
import HeroImg1 from "../../assets/images/InternationalAcademy/hero1.jpg";
import HeroImg2 from "../../assets/images/InternationalAcademy/hero2.jpg";
import HeroImg3 from "../../assets/images/InternationalAcademy/hero3.jpg";
import HeroImg4 from "../../assets/images/InternationalAcademy/hero4.jpg";
import HeroImg5 from "../../assets/images/InternationalAcademy/hero5.jpg";


const Banner = ({ bannerImg }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(0);
  const handleImageLoad = () => {
    setImagesLoaded((prev) => prev + 1);
  };
  useEffect(() => {
    if (imagesLoaded === 2) {
      setIsVisible(true);
    }
  }, [imagesLoaded]);
  return (
    <div className="object-cover w-full mt-0 sm:mt-10 max-h-[550px]">
      <img
        src={bannerImg}
        className="object-contain w-auto  "
        alt=""
        onLoad={handleImageLoad}
      />
    </div>
  );
}

const Hero = () => {

  const bannerdata = [
    {
      id: 0,
      bannerImage: HeroImg0,
      mobile: HeroImg0
    },
    {
      id: 1,
      bannerImage: HeroImg1,
      mobile: HeroImg1
    },
    {
      id: 2,
      bannerImage: HeroImg2,
      mobile: HeroImg2
    },
    {
      id: 3,
      bannerImage: HeroImg3,
      mobile: HeroImg3
    },
    {
      id: 4,
      bannerImage: HeroImg4,
      mobile: HeroImg4
    },
    {
      id: 5,
      bannerImage: HeroImg5,
      mobile: HeroImg5
    }
  ]
  let settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };
  return (
    <div className="mt-24 md:mt-0 ">
      <Slider {...settings} className="z-48">
        {bannerdata?.map((item) => (
          <section className="" id="section-1">
            <Banner bannerImg={item.bannerImage} mobile={item.mobile} />
          </section>
        ))}
      </Slider>
    </div>
  );
};

export default Hero;
